import { render, staticRenderFns } from "./SedimentMenu.vue?vue&type=template&id=5a946633&scoped=true"
import script from "./SedimentMenu.vue?vue&type=script&lang=js"
export * from "./SedimentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a946633",
  null
  
)

export default component.exports